import { useMemo } from "react";
import { useMe } from "@/api/queries/auth";
import type { Client } from "@/api/schemas";
import type { Rol } from "@/routes/routeConfig";
import { resolverPorSlug } from "@/utils/clientes";
import { useSlugDeLaUrl } from "./useSlugDeLaUrl";

export type ClienteActivo =
  | { estado: "cargando"; cliente: null; businessId: ""; slug: null; rol: null }
  | { estado: "fuera-de-cliente"; cliente: null; businessId: ""; slug: null; rol: Rol | null }
  | { estado: "desconocido"; cliente: null; businessId: ""; slug: string; rol: Rol | null }
  | { estado: "activo"; cliente: Client; businessId: string; slug: string; rol: Rol };

/**
 * El cliente de la pantalla. Sale SOLO del segmento `/c/:cliente/` de la URL, resuelto contra `/auth/me`:
 * ni `?business_id=` ni el almacenamiento lo deciden (el almacenamiento solo elige adónde va `/`).
 * `businessId` es `""` mientras no haya cliente activo, para que las consultas se queden `enabled: false`.
 */
export function useClienteActivo(): ClienteActivo {
  const slug = useSlugDeLaUrl();
  const { data: me, isError } = useMe();
  return useMemo((): ClienteActivo => {
    if (!me) return isError && slug ? { estado: "desconocido", cliente: null, businessId: "", slug, rol: null } : { estado: "cargando", cliente: null, businessId: "", slug: null, rol: null };
    if (!slug) return { estado: "fuera-de-cliente", cliente: null, businessId: "", slug: null, rol: me.principal.role };
    const cliente = resolverPorSlug(me.clients, slug);
    if (!cliente) return { estado: "desconocido", cliente: null, businessId: "", slug, rol: me.principal.role };
    return { estado: "activo", cliente, businessId: cliente.business_id, slug, rol: me.principal.role };
  }, [me, isError, slug]);
}
